import { render, staticRenderFns } from "./TaskListBulkDrawers.vue?vue&type=template&id=533ba8fe"
import script from "./TaskListBulkDrawers.vue?vue&type=script&lang=js"
export * from "./TaskListBulkDrawers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports